module.exports = __webpack_public_path__ + "static/media/sample_visa.dd36675c.jpg";